import { useQuery } from '@tanstack/react-query';
import { apiRequest, HttpMethod } from '@api/common';
import { queryKeys } from '@api/queryClient';

// ============================================================================
// Types
// ============================================================================

export interface LoadingInfo {
  id: string;
  deliveryDate: string;
  deliveryNumber: string;
  terminalName: string;
  terminalId: string;
  shipToSapId: string;
  carrierToSapId: string;
  itemSapId: string;
  receivedAt: string;
  originalJsonData: string;
  deleteOriginalJsonData: string;
  disabledAt: string;
  isEnabled: boolean;
  itemNumber: string;
  customerId: string;
  customerName: string;
  shipToCity: string;
  shipToName1: string;
  shipToName2: string;
  shipToPostalCode: string;
  shipToStreet: string;
}

export interface FetchLoadingsParams {
  from: string;
}

// ============================================================================
// API Functions
// ============================================================================

const API_ENDPOINT = 'loadinginfos';

const fetchLoadingInfos = async (from: string): Promise<LoadingInfo[]> => {
  const queryParams = `from=${from || ''}`;
  return apiRequest<void, LoadingInfo[]>(HttpMethod.GET, `${API_ENDPOINT}?${queryParams}`);
};

// ============================================================================
// Query Hooks
// ============================================================================

/**
 * Fetch loading infos with date filter
 */
export const useLoadingInfosQuery = (from: string) => {
  return useQuery({
    queryKey: queryKeys.loadingInfos.list({ from }),
    queryFn: () => fetchLoadingInfos(from),
  });
};
